<template>
  <Modal
    v-model="showModal"
    footer-hide
    :styles="{top: '20px'}"
    @on-visible-change="handleOnClose"
    className="text-center">
    <img src="~@/assets/icons/circled-check.svg" alt="circle check" width="80px" style="margin-top:20px">
    <h3 class="padding-b-20">Done!</h3>
    <p>Your password has been successfully changed.</p>
    <Button class="k-btn-1" @click="handleOnClose(false)" size="large" style="margin:20px 0px;">Log in to Kromnix</Button>
  </Modal>
</template>

<script>
export default {
  data () {
    return {
      showModal: false,
      userType: 'buyer'
    }
  },

  methods: {
    openModal (userType) {
      this.showModal = true
      this.userType = userType
    },
    handleOnClose (val) {
      if (!val) {
        if (this.userType === 'buyer') {
          this.$router.push({
            name: 'buyer-login'
          })
        } else if (this.userType === 'techprovider') {
          this.$router.push({
            name: 'tech-provider-login'
          })
        } else {
          this.$router.push({
            name: 'companies'
          })
        }
      }
    }
  }
}
</script>
